import OpticalImage1 from '../../../assets/images/svgs/imaging/optical_01.png'
import OpticalImage2 from '../../../assets/images/svgs/imaging/optical_02.png'
import FundusImage1 from '../../../assets/images/svgs/imaging/fundus_01.png'
import FundusImage2 from '../../../assets/images/svgs/imaging/fundus_02.png'
import FlurosenceImage1 from '../../../assets/images/svgs/imaging/flurosence_01.png'
import FlurosenceImage2 from '../../../assets/images/svgs/imaging/flurosence_02.png'

const imagingData = {
    progressionList: [
        {
            "title": "Early",
            "content": "Multiple small ({{small}}) and few<br /> intermediate  (63-124 µm)<br /> drusen, or RPE abnormalities.<sup>1-3</sup>"
        },
        {
            "title": "Intermediate",
            "content": "Extensive intermediate drusen (63-124<br /> µm) or more than 1 large druse (≥125<br /> µm). May also be accompanied by<br /> pigmentary and degenerative<br /> changes in the choriocapillaris, RPE<br />, and photoreceptors.<sup>1-4</sup>"
        },
        {
            "title": "Advanced (GA)",
            "content": "Progressive atrophy of choriocapillaris,<br />mRPE, and photoreceptors. <sup>2,3</sup>As well as<br /> new and growing lesions.<sup>3</sup>"
        }
    ],
    imageListData: [
        {
            "title": "Optical Coherence Tomography (OCT)",
            "intermediateImageUrl": OpticalImage1,
            "intermediateImageDesc": "Image courtesy of Dr. Arshad Khanani",
            "advancedImageUrl": OpticalImage2,
            "advancedImageDesc": "Image courtesy of Dr. Arshad Khanani",
            "featuresTitle": "Key Features<sup>1,4</sup>",
            "feauturesCourtsey":"Images are from separate patients.",
            "features": [
                "(1) Degeneration of overlying photoreceptors increases reflectivity below Bruch’s membrane",
                "(2) Hyperreflective foci corresponds to attenuation or disruption of the RPE",
                "(3) Atrophy of the RPE",
                "(4) Area of choroidal hypertransmission"
            ]
        },
        {
            "title": "Color Fundus Photography (CFP)",
            "intermediateImageUrl": FundusImage1,
            "intermediateImageDesc": "Image courtesy of Dr. Arshad Khanani",
            "advancedImageUrl": FundusImage2,
            "advancedImageDesc": "Image courtesy of Dr. Mohammed Rafieetary",
            "featuresTitle": "Key Features<sup>4,6</sup>",
             "feauturesCourtsey":"Images are from separate patients.",
            "features": [
                "(1) Drusen and",
                "(2) hyperpigmentary RPE abnormalities",
                "(3) GA lesion borders are sharply demarcated with increased choroidal vessel visibility (dashed circle)"
            ]
        },
        {
            "title": "Fundus Autofluorescence (FAF)",
            "intermediateImageUrl": FlurosenceImage1,
            "intermediateImageDesc": "Image courtesy of Dr. Arshad Khanani",
            "advancedImageUrl": FlurosenceImage2,
            "advancedImageDesc": "Image courtesy of Dr. David Lally",
            "featuresTitle": "Key Features<sup>1,8</sup>",
             "feauturesCourtsey":"Images are from separate patients.",
            "features": [
                "(1) Reticular pseudodrusen appearing as multiple, clustered, regularly orked, round areas of low-contrast hypo-autofluorescence may be prognostic of advancing AMD",
                "(2) Abnormal patterns of hyperautofluorescence surrounding atrophic lesions",
                "(3) Areas of hypoautofluorescence with sharply demarcated borders indicate atrophic lesions"
            ]
        }
    ]
}
export default imagingData